import { render } from "./CvToastNotification.vue?vue&type=template&id=628c0e7e"
import script from "./CvToastNotification.vue?vue&type=script&lang=js"
export * from "./CvToastNotification.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/carbon-components-vue/carbon-components-vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__